// The "More" chip at the end of every row of options in a guided panel (the tent flow and the venue flow share it).
//
// It is never an answer: it sets nothing, redraws nothing, and only opens (or closes) the message under its row about what signing up
// unlocks. One message is open at a time, and a message that opens low in the panel brings itself into view so its button is not off
// the edge. `root` is the panel's element; the chips and messages are found by `data-more`.
export default class MoreMessages {
  constructor(root) {
    this.root = root
  }

  toggle(chip) {
    const opening = chip.getAttribute("aria-expanded") !== "true"
    this.closeAll()
    if (opening) this.open(chip)
  }

  open(chip) {
    const message = this.root.querySelector(`#${CSS.escape(chip.getAttribute("aria-controls"))}`)
    chip.setAttribute("aria-expanded", "true")
    message.hidden = false
    message.scrollIntoView({ block: "nearest", behavior: "smooth" })
  }

  // The message's own Close button, or Escape: closes it and gives focus back to the chip that opened it.
  close(element) {
    const chip = this.chipFor(element)
    this.closeAll()
    chip?.focus()
  }

  keydown(event) {
    if (event.key !== "Escape" || !this.anyOpen()) return

    event.stopPropagation()
    this.close(event.currentTarget)
  }

  closeAll() {
    this.root.querySelectorAll("[data-more=chip]").forEach((chip) => chip.setAttribute("aria-expanded", "false"))
    this.root.querySelectorAll("[data-more=message]").forEach((message) => { message.hidden = true })
  }

  anyOpen() {
    return this.root.querySelector("[data-more=chip][aria-expanded=true]") !== null
  }

  // The chip a message or a chip belongs to: a message is found by its id, which its chip names in aria-controls.
  chipFor(element) {
    const message = element.closest("[data-more=message]")
    return message ? this.root.querySelector(`[aria-controls="${message.id}"]`) : element
  }
}
